import App from "./App";

import { FastSearch } from "./Common/FastSearch";

import { DevicesSummary } from "./Dash/DevicesSummary";
import { DevicesToSet } from "./Dash/DevicesToSet";
import { Actions } from "./Dash/Actions";
import { TopCustomers } from "./Dash/TopCustomers";

import { Wrapper as FleetWrapper } from "./Fleet/Wrapper";
import { Search as FleetSearch } from "./Fleet/Search";
import { AverageData } from "./Fleet/AverageData";
import { BatteryList } from "./Fleet/BatteryList";
import { LogsStats as FleetLotsStats } from "./Fleet/LogsStats";

import { Summary } from "./BatteryOverview/Summary";
import { LastState } from "./BatteryOverview/LastState";
import { Soh } from "./BatteryOverview/Soh";
import { Charge as BatteryOverviewCharge } from "./BatteryOverview/Charge";
import { LastCycle } from "./BatteryOverview/LastCycle";

import { MaintenanceList } from "./BatteryLife/MaintenanceList";
import { Temp as BatteryLifeTemp } from "./BatteryLife/Temp";
import { LogsStats as BatteryLifeLogsState } from "./BatteryLife/LogsStats";

import { LastState as BatteryCycleLastState } from "./BatteryCycle/LastState";
import { SingleCycle } from "./BatteryCycle/SingleCycle";
import { Charge as BatteryCycleCharge } from "./BatteryCycle/Charge";
import { Temp as BatteryCycleTemp } from "./BatteryCycle/Temp";
import { Stats } from "./BatteryCycle/Stats";
import { Cycles } from "./BatteryCycle/Cycles";

import { Device as SettingsDevice } from "./Settings/Device";
import { Battery as SettingsBattery } from "./Settings/Battery";
import { Truck as SettingsTruck } from "./Settings/Truck";
import { Dealer as SettingsDealer } from "./Settings/Dealer";
import { Department as SettingsDepartment } from "./Settings/Department";
import { Customer as SettingsCustomer } from "./Settings/Customer";
import { User as SettingsUser } from "./Settings/User";
import { Device as SettingsDeviceList } from "./Settings/List/Device";
import { Battery as SettingsBatteryList } from "./Settings/List/Battery";
import { Truck as SettingsTruckList } from "./Settings/List/Truck";
import { Dealer as SettingsDealerList } from "./Settings/List/Dealer";
import { Department as SettingsDepartmentList } from "./Settings/List/Department";
import { Customer as SettingsCustomerList } from "./Settings/List/Customer";
import { User as SettingsUserList } from "./Settings/List/User";


// UI
import Ratio from "./UI/Ratio";
import Box from "./UI/Box";
import Modal from "./UI/Modal";
import Gauge from "./UI/Gauge2";
import GaugeCustom from "./UI/GaugeCustom";
import LoadingMini from './UI/LoadingMini';

export {
    App,

    FastSearch,
    
    DevicesSummary, DevicesToSet, Actions, TopCustomers,
    FleetWrapper, FleetSearch, AverageData, BatteryList, FleetLotsStats,
    Summary, LastState, Soh, BatteryOverviewCharge, LastCycle,
    MaintenanceList, BatteryLifeTemp, BatteryLifeLogsState,
    SingleCycle, BatteryCycleLastState, BatteryCycleCharge, BatteryCycleTemp, Stats, Cycles,
    SettingsDevice, SettingsBattery, SettingsTruck, SettingsDealer, SettingsDepartment, SettingsCustomer, SettingsUser,
    SettingsDeviceList, SettingsBatteryList, SettingsTruckList, SettingsDealerList, SettingsDepartmentList, SettingsCustomerList, SettingsUserList,
    
    
    Ratio, Box, Modal, Gauge, GaugeCustom, LoadingMini
}


// WEBPACK FOOTER //
// ./src/components/index.tsx